export class ExtranetVersionService{

  private _currentVersion: string;
  private _newVersion: string="0.0.0.0";

  private _downloadUrl: string;
  private _needUpdate: boolean = false;

  public get currentVersion(): string {
    return this._currentVersion;
  }

  public get newVersion(): string {
    return this._newVersion;
  }

  public set currentVersion(value:string){
    this._currentVersion = value;
  }
  public set newVersion(value:string){
    this._newVersion=value;
  }
  
  public get downloadUrl():string{
    return `${this._downloadUrl}/${this.exeName(this.newVersion)}`
  }

  public set downloadUrl(value: string){
    this._downloadUrl=value;
  }

  public get needUpdate():boolean{
    return this._needUpdate;
  }

  public checkVersion(){
    if(this.currentVersion===undefined){
      this._needUpdate = true;  
    }
    if(this.newVersion=== undefined || this.currentVersion=== undefined){
      return;
    }
    const newArray =  this.versionNumberArray(this.newVersion);
    const currentArray = this.versionNumberArray(this.currentVersion);
    
  
    this._needUpdate = this.checkVersionArray(currentArray,newArray);
    
  }
  private checkVersionArray(currentArray:number[], newArray:number[]){
    for(let i=0;i<4;i++){
      if(currentArray[i] < newArray[i]){
          return true;
      }else if(currentArray[i] > newArray[i]){
        return false;
      }
    }
    return false;
  }
  private versionNumberArray(version:string){
      const numbers: number[] = [0,0,0,0];
      const vitems: string[] = version.split('.');
      for(let i = 0 ;i<vitems.length;i++){
          numbers[i] = +vitems[i];
      }
      return numbers;
  }
  private exeName(newVersion: string){
    const env =(<any>window).masterlink?.extranetEnv;
    if(env==='release'|| env==='')
    {
      return `WimiExtranetSetup-V${newVersion}.exe`;
    }
    return `WimiExtranet${this.titleCaseWord(env)}Setup-V${newVersion}.exe`;
  }
  private titleCaseWord(word: string){
    if (!word) return word;
    return word[0].toUpperCase() + word.substring(1).toLowerCase();
  }


}

export function createExtranetVersionService(){
  return new ExtranetVersionService()
}